import { render, staticRenderFns } from "./pika.vue?vue&type=template&id=c7e36950&lang=pug&"
import script from "./pika.vue?vue&type=script&lang=js&"
export * from "./pika.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports